/* Bellori — barre promo : compte à rebours réel (tick 1 s), fin → masquage, copie du code,
   ligne « encore … » de la fiche produit, nettoyage des éléments promo si la promo vient de se terminer.
   L'état initial (window.BelloriPromo) est posé par le script inline de sections/promo-bar.liquid. */
(function () {
  'use strict';
  var timer = null;
  var lastAria = '';

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function p2(n) { return (n < 10 ? '0' : '') + n; }
  function fmtMoney(cents) {
    var n = cents / 100;
    var s = Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ',');
    return s + ' €';
  }

  /* Fin de promo (compteur à zéro, ou page en cache) : retirer badges / encart / ligne panier, restaurer les prix */
  function endPromo() {
    var P = window.BelloriPromo || (window.BelloriPromo = {});
    P.active = false;
    var html = document.documentElement;
    html.classList.remove('bl-promo-on');
    html.classList.remove('bl-promo-active');
    html.classList.add('bl-promo-stale');
    var bar = document.getElementById('bl-promo-bar');
    if (bar) bar.hidden = true;
    qsa('[data-promo-price][data-orig]').forEach(function (el) {
      var orig = parseInt(el.getAttribute('data-orig'), 10);
      if (!isNaN(orig)) el.textContent = (el.getAttribute('data-prefix') || '') + fmtMoney(orig);
    });
    qsa('[data-promo-was]').forEach(function (el) {
      var w = parseInt(el.getAttribute('data-orig-was') || '0', 10);
      var o = parseInt(el.getAttribute('data-orig') || '0', 10);
      if (w > o) { el.textContent = fmtMoney(w); el.hidden = false; } else { el.hidden = true; }
    });
    qsa('[data-promo-badge]').forEach(function (el) {
      var w = parseInt(el.getAttribute('data-orig-was') || '0', 10);
      var o = parseInt(el.getAttribute('data-orig') || '0', 10);
      if (w > o) { el.textContent = '−' + Math.round((1 - o / w) * 100) + ' %'; el.hidden = false; } else { el.hidden = true; }
    });
    try { document.dispatchEvent(new CustomEvent('bellori:promo-end')); } catch (e) {}
  }

  function tick() {
    var P = window.BelloriPromo;
    if (!P || !P.active) { stop(); return; }
    var left = P.end - Math.floor(Date.now() / 1000);
    if (left <= 0) { stop(); endPromo(); return; }
    var d = Math.floor(left / 86400), h = Math.floor(left / 3600) % 24, m = Math.floor(left / 60) % 60, s = left % 60;
    qsa('[data-promo-timer]').forEach(function (t) {
      var set = function (u, v) { var el = t.querySelector('[data-u="' + u + '"]'); if (el && el.textContent !== v) el.textContent = v; };
      set('d', p2(d)); set('h', p2(h)); set('m', p2(m)); set('s', p2(s));
      // Accessibilité : libellé mis à jour à la minute seulement
      var aria = 'Fin dans ' + d + ' jours ' + h + ' heures ' + m + ' minutes';
      if (aria !== lastAria) { t.setAttribute('aria-label', aria); lastAria = aria; }
    });
    qsa('[data-promo-remaining]').forEach(function (el) {
      var txt = (d > 0 ? d + ' j ' : '') + p2(h) + ' h ' + p2(m) + ' min';
      if (el.textContent !== txt) el.textContent = txt;
    });
  }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function start() {
    stop();
    var P = window.BelloriPromo;
    if (!P || !P.active) return;
    tick();
    timer = setInterval(tick, 1000);
  }

  document.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-promo-copy]');
    if (copy) {
      var code = copy.getAttribute('data-code') || '';
      var done = function () {
        var lbl = copy.querySelector('[data-copy-label]');
        if (!lbl) return;
        lbl.textContent = 'Copié ✓';
        setTimeout(function () { lbl.textContent = 'Copier'; }, 1600);
      };
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
        else done();
      } catch (err) { done(); }
    }
  });

  // Page en cache rendue « promo » alors qu'elle est finie : restaurer les prix tout de suite
  if (document.documentElement.classList.contains('bl-promo-stale')) endPromo();
  start();

  // Éditeur de thème : la section est re-rendue à chaque changement de réglage
  document.addEventListener('shopify:section:load', function () { start(); });
})();
